import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    title: 'pages.onboarding.education.veryConfident',
    subtitle: 'pages.onboarding.education.veryConfidentSub',
    value: 'very-confident',
  },
  {
    title: 'pages.onboarding.education.fairlyConfident',
    subtitle: 'pages.onboarding.education.fairlyConfidentSub',
    value: 'fairly-confident',
  },
  {
    title: 'pages.onboarding.education.unsure',
    subtitle: 'pages.onboarding.education.unsureSub',
    value: 'unsure',
  },
  {
    title: 'pages.onboarding.education.worried',
    subtitle: 'pages.onboarding.education.worriedSub',
    value: 'worried',
  },
  {
    title: 'pages.onboarding.education.notConfident',
    subtitle: 'pages.onboarding.education.notConfidentSub',
    value: 'not-confident',
  },
]

export default function EducationPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.education.title"
      subtitle="pages.onboarding.education.subtitle"
    />
  )
}
